"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultToggleGroupTheme = void 0;
// Root types

// Item types

// Combined types

const defaultToggleGroupTheme = exports.defaultToggleGroupTheme = {
  defaultProps: {
    variant: "secondary"
  },
  defaultStyle: {
    item: {
      backgroundColor: "transparent",
      color: "--black",
      checked: {
        color: "--white"
      },
      disabled: {
        color: "--neutral-a32",
        checked: {
          backgroundColor: "--neutral"
        }
      },
      hover: {
        backgroundColor: "--neutral-400"
      },
      invalid: {
        checked: {
          backgroundColor: "--danger"
        }
      },
      pressed: {
        backgroundColor: "--neutral"
      }
    },
    root: {
      borderColor: "--neutral-400",
      focusVisible: {
        borderColor: "--accent"
      },
      invalid: {
        borderColor: "--danger"
      }
    }
  },
  variant: {
    primary: {
      item: {
        checked: {
          backgroundColor: "--primary"
        }
      },
      root: {}
    },
    secondary: {
      item: {
        checked: {
          backgroundColor: "--black"
        }
      },
      root: {}
    }
  }
};
//# sourceMappingURL=defaultToggleGroupTheme.js.map